export default __webpack_public_path__ + "static/media/dashboardWhite.e42d56fd.png";